import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=1b22f868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b22f868"]])

export default __exports__